module.exports = __webpack_public_path__ + "img/MicrosoftStore.92ae5185.png";